import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductProvider } from "~/contexts/ProductContext";
import { ManuscriptDetails } from "~/pages/UploadManuscript/ManuscriptDetails";
import { ManuscriptRouteGuard } from "~/pages/UploadManuscript/ManuscriptRouteGuard";

export const Route = createFileRoute("/_app/manuscripts/$productId")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.manuscript") }],
  }),
  component: ManuscriptRoute,
});

function ManuscriptRoute() {
  const { productId } = Route.useParams();

  return (
    <ManuscriptRouteGuard>
      <ProductProvider id={productId}>
        <ManuscriptDetails />
      </ProductProvider>
    </ManuscriptRouteGuard>
  );
}
